import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { SFStack, SFTypography, SFUseStyled } from "@sf-core";
import { ColorFlag, ColorCase } from "../icons";

const { styled } = SFUseStyled();

const SFStackStyled = styled(SFStack)(() => ({
  height: "100%",
  width: "100%",
  cursor: "pointer",
}));

const SFTypographyBody = styled(SFTypography)(({ theme }) => ({
  whiteSpace: "break-spaces",
  overflow: "hidden",
  display: "-webkit-box",
  WebkitLineClamp: 1,
  WebkitBoxOrient: "vertical",
  textOverflow: "ellipsis",
}));

const getSkillType = (skill, labels) => {
  const isSkillGoal = skill.isSkillGoal;
  const isJobRoleSkill = skill.isJobRoleSkill;

  return (
    <SFStack direction="row" spacing={2}>
      {isSkillGoal && (
        <SFStack alignItems="center" direction="row" spacing={0.5}>
          <ColorFlag />
          <SFTypography variant="body1">{labels.isSkillGoalLabel}</SFTypography>
        </SFStack>
      )}
      {isJobRoleSkill && (
        <SFStack alignItems="center" direction="row" spacing={0.5}>
          <ColorCase />
          <SFTypography variant="body1">{labels.isJobSkillLabel}</SFTypography>
        </SFStack>
      )}
    </SFStack>
  );
};

const SFSkillTypesRenderer = ({ value, data, ...props }) => {
  const { t } = useTranslation();
  return (
    <SFStackStyled justifyContent="center" onClick={() => props.onClick(data)}>
      <SFTypographyBody variant="body1">{value}</SFTypographyBody>
      {data.expanded && (
        <>
          {getSkillType(data, {
            isSkillGoalLabel: t("dashboardScreen.isSkillGoalLabel"),
            isJobSkillLabel: t("dashboardScreen.isJobRoleSkillLabel"),
          })}
        </>
      )}
    </SFStackStyled>
  );
};

SFSkillTypesRenderer.propTypes = {
  value: PropTypes.any,
};

export default SFSkillTypesRenderer;
